export const animate = (callback, duration = 1000) => new Promise(resolve => {
    const requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame;
    let startTime = 0;
    let percentage = 0;
    let animationTime = 0;
    const animation = timestamp => {
        if (startTime === 0) {
            startTime = timestamp;
        } else {
            animationTime = timestamp - startTime;
        }

        if (percentage <= 1) {
            percentage = animationTime / duration;
            callback(percentage);
            requestAnimationFrame(animation);
        } else {
            resolve();
        }
    };

    requestAnimationFrame(animation);
});
